module.exports = __webpack_public_path__ + "img/thumbnail_BorneanPygmyElephant_j_normal.5ada50c4.png";